import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-accent-500';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3">
            热门排行
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            芭乐视频本周最受欢迎影视内容推荐
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 py-4 md:py-5 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-[10px] text-foreground-400 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 truncate">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <i className={`text-sm ${trendIcon(item.trend)}`}></i>
                <span className="text-sm font-bold text-primary-500 font-heading">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}